import { ApolloProvider } from '@apollo/client';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { initialLocale, LocaleActivationProvider, RegionMappingsProvider } from '@fsd/app/locale';
import { Outlet } from 'react-router-dom';
import { AuthProvider } from './contexts/JWTContext';
import { fsdRegionMappings } from './fsdRegionMappings';
import { client } from './graphql';
import { activateLocale } from './utils/i18n/activateLocale';

// En la rama MUI esto lo hace useI18n, que esta rama no carga. Arranca en el último idioma conocido
// (o el del navegador) y, cuando llega, manda la preferencia del usuario (`fsd/app/locale`). Si el
// catálogo no carga, cae a español (va en el bundle): sin un idioma activo Lingui no dibuja nada.
activateLocale(initialLocale()).catch(() => activateLocale('es'));

// Rama de las rutas de src/fsd/: sin MUI, Redux ni los componentes globales del producto.
// Vive aparte de AppContexts.tsx porque importar ese archivo descarga la rama MUI entera.
// El scroll lo maneja el `ScrollRestoration` de AppLayout: un reset por navegación lo pisaría.
export const FsdContext = () => (
  <ApolloProvider client={client}>
    <I18nProvider i18n={i18n}>
      <AuthProvider>
        {/* `fsd/` no puede importar `utils/i18n`: el activador del idioma y las tablas de la
            región le llegan inyectados. */}
        <LocaleActivationProvider activate={activateLocale}>
          <RegionMappingsProvider mappings={fsdRegionMappings}>
            <Outlet />
          </RegionMappingsProvider>
        </LocaleActivationProvider>
      </AuthProvider>
    </I18nProvider>
  </ApolloProvider>
);
